<template>
  <div>
    <div class="structure_date">
      <div class="structure_date__date">
        <p>Selecciona la hora</p>
      </div>      
    </div>
    <div v-if="is_changed"
        class="time_select">
      <div
      v-for="(hour,index) in all_bookings" :key="index"
      :class="sublocationSpaces > 0 && hour.bookings === 0 ? 'time_select__item' : 'time_select__item_inactive' ">
        <div :class="sublocationSpaces > 0 && hour.bookings === 0 ? 'time_select__item--begin' : 'time_select__item_inactive--begin'">
          <p>Ingreso</p>
          <div>
              <img src="@/assets/img/sportlife/flecha-entrada-verde.svg" alt="">
              <span>{{ convertHourToStyleFormat(hour.beginning) }}</span>
          </div>
        </div>
        <div :class="sublocationSpaces > 0 && hour.bookings === 0 ? 'time_select__item--end' : 'time_select__item_inactive--end'">
          <p>Salida</p>
          <div>
              <img src="@/assets/img/sportlife/flecha-salida-roja.svg" alt="">
              <span>{{ convertHourToStyleFormat(hour.ending) }}</span>
          </div>
        </div>
        <div :class="sublocationSpaces > 0 && hour.bookings === 0 ? 'time_select__item--session' : 'time_select__item_inactive--session'">
          <p>Sesión</p>
          <div>
          <img src="@/assets/img/sportlife/icono-fecha.svg" alt="">
          <span>{{ convertTimeToString(sublocationTime) }}</span>
          </div>
        </div>
        <!-- <div :class="hour.click===true ? 'time_select__item_select--session':'time_select__item--session'">
          <p>Cupos disponibles</p>
          <div>
          <img src="@/assets/img/if/icono-user.svg" alt="">
          <span>{{ sublocationSpaces- hour.bookings }}</span>
          </div>
        </div> -->
        <div :class="sublocationSpaces > 0 && hour.bookings === 0 ? 'time_select__item--session' : 'time_select__item_inactive--session' ">
          <p>Máximo de personas</p>
          <div>
          <img src="@/assets/img/sportlife/icono-user.svg" alt="">
          <span>{{ sublocationSpaces }}</span>
          <!-- <span>{{ hour.bookings }}</span> -->
          </div>
        </div>
        <button @click.stop="sublocationSpaces > 0 && hour.bookings === 0 ? clickBooking(hour.beginning, hour.ending, index) : ''"
          :class="sublocationSpaces > 0 && hour.bookings === 0 ? 'time_select__item--button': 'time_select__item_inactive--button'">
          {{ sublocationSpaces > 0 && hour.bookings === 0 ? 'Agendar horario' : 'Reservado'  }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        data() {
            return {
                schedules:[],
                days:["sunday","monday","tuesday","wednesday", "thursday", "friday", "saturday"],
                sublocationTime:"0:00",
                sublocationSpaces:0,
                time_zone: '',
                country: '',
                gtm: '',
                location_time_zone: '',
                date: '',
                sublocation: '',
                is_changed: false,
                dataSelector: {
                  init: "",
                  end: ""
                },
                minutes: [
                  { value: 15 , label: '15 minutos', sublocation_time: '0:15' },
                  { value: 30 , label: '30 minutos', sublocation_time: '0:30' },
                  { value: 60 , label: '1  hora', sublocation_time: '1:00' },  
                ],
                interval: 60,
                bookings: [],
                sublocation_schedule: '',
                all_bookings: []
            }
        },
        mounted(){
          this.date = this.getBookingDate()/* this.$route.params.date */
          console.log('dato',this.date)
          this.sublocation = this.$route.params.sublocation
          var vm = this;
          this.requestPosibleBookings();
          /* this.generateSchedule(); */
        },
        methods: {
            requestPosibleBookings(){
                var vm = this;
                let current_date = new Date();
                let local_date = current_date.toISOString().substr(0, 10)
                let current_datetime = null
                if (vm.date.toISOString().substr(0, 10) === this.current_datetime().substring(0,this.current_datetime().lastIndexOf(' ')) ){
                  let f = current_date.toISOString();
                  current_datetime = f.substring(f.indexOf('T') + 1,f.indexOf('T') + 6);
                }
                try{
                    vm.$http.get('app/bookings/reservations_available', {
                        headers: {
                            "X-Device-ID" : this.getDeviceId(),
                            "Authorization" : 'Bearer ' + this.getUserToken()
                        },
                        params:{
                            sublocation_id: this.getSublocationId(),
                            date: vm.date.toISOString().substr(0, 10),
                            current_date: current_date.toISOString(),
                            current_datetime: current_datetime,
                            day: vm.days[vm.date.getDay()]
                            }

                    }).then(function(response){
                        this.is_changed = false
                        console.log("TIME SELECE BOOKING ",response );
                        vm.schedules=response.body.schedule
                        vm.sublocationSpaces=response.body.sublocation_spaces
                        vm.sublocationTime=response.body.sublocation_time
                        vm.location_time_zone=response.body.time_zone
                        vm.time_zone=response.body.time_zone.substring(response.body.time_zone.indexOf('/') + 1,response.body.time_zone.length).replace(/[_]/g, ' ')
                        vm.country=response.body.country
                        vm.gtm=response.body.gtm.replace(/[0]/g,'')
                        vm.bookings=response.body.bookings
                        vm.sublocation_schedule=response.body.sublocation_schedule
                        this.generateSchedule();
                        /* for (let i = 0; i < vm.schedules.length; i++){
                        vm.styles.push({ style_height: 70 , click: false })
                        }
                         */
                        if(response.body.meta != undefined && response.body.meta != null){
                            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
                                this.checkToken(response.body.meta.authentication_token)
                            }
                        }
                        this.is_changed = true
                  }, function(response){
                    if(response.body.meta != undefined && response.body.meta != null){
                      if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
                        this.checkToken(response.body.meta.authentication_token)
                      }
                    }
                    /* console.log("=====Response=====");
                    console.log("Respuesta error de reservas"); */
                    if (response.status==401) {
                      // alert(response.body.errors[0].details, "Un momento...");
                      this.updateAlertMessage("Tienes una sesión abierta en otro dispositivo.", "Un momento...");
                      this.updateIsInAlert(true)
                    }else{
                      this.updateAlertMessage(response.body.errors[0].details);
                      this.updateIsInAlert(true)
                    }
                  });
                }catch(e){
                  console.log("Fallo reservas home");
                  this.updateAlertMessage(e.message);
                  this.updateIsInAlert(true)
                }

                vm.is_changed = false;
            },
            convertHourToStyleFormat(hour){
                var arr=hour.split(":")
                var amOrPm="am"
                if(arr[0]>=12){
                    amOrPm="pm"
                    if(arr[0]>12){
                    arr[0]= Number(arr[0])%12
                    }
                }else if(arr[0]==0){
                    arr[0]=12
                }
                if(Number(arr[0])<10){
                    arr[0]="0"+Number(arr[0]).toString()
                }
                return arr[0]+":"+arr[1]+" "+amOrPm;
            },
            clickBooking(schedule_beginning,schedule_ending,index){
            var vm = this;
            /*  this.$emit('selected',
                        { start_time: schedule_beginning,
                          end_time: schedule_ending,
                          index: index,
                        })  */
            let arr = vm.date.toISOString();
            
            let offset = new Date().getTimezoneOffset();

            this.dataSelector.init = new Date(
              new Date(arr).getTime() + offset * 60000
            );
            this.dataSelector.end = new Date(
              new Date(arr).getTime() + offset * 60000
            );
            var iniHourArr = schedule_beginning.split(":");
            var final_start_time = this.mixDateHour(
              this.dataSelector.init,
              Number(iniHourArr[0]),
              Number(iniHourArr[1])
            );
            var endHourArr = schedule_ending.split(":");
            var final_end_time = this.mixDateHour(
              this.dataSelector.end,
              Number(endHourArr[0]),
              Number(endHourArr[1])
            );

            this.$router.push({ name: 'user_booking',
              params: {
                  sublocation_id: vm.sublocation,
                  weekday: vm.days[vm.date.getDay()],
                  start_time: final_start_time,
                  end_time: final_end_time,
                  day_schedule: index,
                  local_time: schedule_beginning,
                  location_time_zone: vm.location_time_zone,
                }
              })
            },
            mixDateHour(date, hour, minutes) {

              let myDate = date;
              myDate.setHours(hour);
              myDate.setMinutes(minutes);

              let offset = new Date().getTimezoneOffset();

              let timeZone = this.location_time_zone

              let a = new Date()
                .toLocaleString("ja", { timeZone: timeZone })
                .split(/[/\s:]/);
              a[1] = a[1] - 1;
              let t1 = Date.UTC.apply(null, a);
              let t2 = new Date().setMilliseconds(0);
              let bookingOffset = (t2 - t1) / 60 / 1000;
              let ans = new Date(
                myDate.getTime() - offset * 60000 + bookingOffset * 60000
              );
              return ans.toJSON();
            },
            convertTimeToString(hh){
              let hour = String(hh)
              let h = hour.substring(0,hour.indexOf(':'))
              let m = hour.substring(hour.indexOf(':') + 1,hour.length)
              return h + " h " + m + " m"
            },
            current_datetime: function(){
              let date = new Date();
              let dateStr =
                date.getFullYear() + "-" +
                ("00" + (date.getMonth() + 1)).slice(-2) + "-" +
                ("00" + date.getDate()).slice(-2) + " " +
                ("00" + date.getHours()).slice(-2) + ":" +
                ("00" + date.getMinutes()).slice(-2) + ":" +
                ("00" + date.getSeconds()).slice(-2);
                return dateStr
            },
            generateSchedule(){
              let interval = this.interval;
              let current_date = new Date();
              console.log('this.date ', this.date.toISOString().substr(0, 10))
              let date_initial = new Date(`${this.date.toISOString().substr(0, 10)} ${this.sublocation_schedule.begin}:00.000`)
              let date_final   = new Date(`${this.date.toISOString().substr(0, 10)} ${this.sublocation_schedule.end}:00.000`)
              let schedules = []
              let schedules_delete = []
              let nex_time = null
              let date_interval = null
              while (true) {
                date_interval = new Date(date_initial).setMinutes(date_initial.getMinutes() + interval)
                nex_time = new Date(date_interval)
                if (date_initial >= current_date && nex_time <= date_final){ 
                  if (this.bookings.length > 0){
                    let booking_start = null
                    let booking_end = null
                    for(let i = 0; i < this.bookings.length; i++ ){
                      booking_start = new Date(this.bookings[i].start_time.substring(0,19).replace("T"," ") )
                      booking_end = new Date(this.bookings[i].end_time.substring(0,19).replace("T"," ") )
                      if ((booking_start >= date_initial && booking_start < nex_time)||(booking_end > date_initial && booking_end <= nex_time) ){ 
                        if(schedules_delete.find(e => JSON.stringify(e) === JSON.stringify({ beginning:  date_initial.toTimeString().substring(0,5), ending: nex_time.toTimeString().substring(0,5) , bookings: 0 }) )){
                        }else {
                          schedules_delete.push({ beginning:  date_initial.toTimeString().substring(0,5), ending: nex_time.toTimeString().substring(0,5) , bookings: 0 }) 
                        }
                      } 
                      if(schedules.find(e => JSON.stringify(e) === JSON.stringify({ beginning:  date_initial.toTimeString().substring(0,5), ending: nex_time.toTimeString().substring(0,5) , bookings: 0 }) )){
                      }else {
                        schedules.push({ beginning:  date_initial.toTimeString().substring(0,5), ending: nex_time.toTimeString().substring(0,5) , bookings: 0 }) 
                      }
                    }
                  } else { 
                    schedules.push({ beginning:  date_initial.toTimeString().substring(0,5), ending: nex_time.toTimeString().substring(0,5) , bookings: 0 })
                  } 
                }
                if (nex_time > date_final){
                  break
                }
                date_initial = nex_time
              }
              this.sublocationTime = this.minutes.find( e => e.value === this.interval ).sublocation_time
              for(let i = 0;i < schedules.length; i++){
                for(let k = 0;k < schedules_delete.length; k++){
                  if (schedules[i].beginning === schedules_delete[k].beginning && schedules[i].ending === schedules_delete[k].ending && schedules[i].bookings === schedules_delete[k].bookings){
                    schedules.splice(i, 1)   
                  }
                }
              }

              this.all_bookings = schedules
              
              console.log(' HORARIOS ===> ',  schedules)
              console.log(' HORARIOS DELETE ===> ',  schedules_delete)
              console.log(' RESERVAS ===> ',  this.bookings)
            }
        },/* Close methods */
        filters:{
            spanishDate(value){
                var myTime=value.getDay();
                var weekday=null
                if(!isNaN(myTime)){
                    weekday=['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'][myTime];
                }
                var month="Mes"
                if(!isNaN(value.getMonth())){
                    month=["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"][value.getMonth()]
                }
                return weekday + " " + value.getDate() + " de " + month
            }
        },
        computed:{
          timeZoneLocal: function(){
            let resolvedOptions = Intl.DateTimeFormat().resolvedOptions()
            return resolvedOptions.timeZone
          },
          computedSchedule(){
            return this.generateSchedule();
          } 
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/views/locations/sublocations/bookings/TimeSelectBooking.vue